/* eslint-disable */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { isLoaded } from 'react-redux-firebase';
import { InstantSearch, Hits, SearchBox } from 'react-instantsearch/dom';
import { AppView, ListSection, ListItem } from 'medua-components';

import ModalAddCourse from './modals/add';

/* eslint-disable */
// const populateCourses = [{ child: 'courses', root: 'courses'}]
// @firebaseConnect()
// @connect(({ schooldata, firebase }) => ({
//   courses: populate(firebase, 'schooldata', populateCourses),
// }))
@translate(['courses', 'degree'])
export default class Courses extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modalAddIsOpen: false,
    }

    this.openAddModal = this.openAddModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.course = this.course.bind(this);
  }

  openAddModal() {
    this.setState({ modalAddIsOpen: true });
  }
  closeModal() {
    this.setState({ modalAddIsOpen: false });
  }

  renderCourses(jobs) {
    return Object.keys(jobs).map((job, index) =>
      <ListItem duo
        key={ index }
        url={ '/courses/' + job }
        title={ jobs[job].name } />
    )
  }

  course({ hit }) {
    return (
      <ListItem
        duo
        className="small"
        title={ hit.name }
        meta={ hit.duration.type ? this.props.t(`duration:type.${hit.duration.type}`) : '' }
        subtitle={ hit.degree.title ?
                    <span>{ this.props.t(`degree:title.${hit.degree.title}`) }</span>
                  : hit.degree.type ?
                    <span>{ hit.degree.type }</span>
                  :
                    <span>{ 'You have to set a degree' }</span>
                  }
        url={`/courses/${ hit.objectID }`} />
    );
  }

  render() {
    let { schooldata } = this.props

    return (
      <AppView
        loading={ !isLoaded(schooldata) }
        title={ this.props.t('courses:title') }
        color="turquoise"
        headerActionRight={[
          { icon: 'add', action: this.openAddModal }
        ]}
        modals={[
          {
            key: 1,
            show: this.state.modalAddIsOpen,
            close: this.closeModal,
            content: <ModalAddCourse
                        closeModal={ this.closeModal }
                        school={ this.props.user.school } />
          }
        ]}>
        { schooldata && schooldata['courses-pending'] &&
          <ListSection toggle
            loading={ !isLoaded(schooldata) }
            empty={{
              state: schooldata && !schooldata['courses-pending'],
              text: this.props.t('connect:modules.empty.text')
            }}
            title={ this.props.t('courses:pending') }>
            { schooldata && schooldata['courses-pending'] && this.renderCourses(schooldata['courses-pending']) }
          </ListSection>
        }
        { schooldata &&
          <ListSection toggle
            loading={ !isLoaded(schooldata) }
            title={ this.props.t('courses:official') }>
            <InstantSearch
              appId="YCR2RQRIW6"
              apiKey="2474d844d2cc2f4623aa31debdabb092"
              indexName="courses"
              searchState={{
                query: this.props.user.school.name ? this.props.user.school.name : this.props.user.school
              }}>
              <div style={{ display: 'none' }}>
                <SearchBox className="input-text" />
              </div>
              <Hits hitComponent={this.course} />
            </InstantSearch>
          </ListSection>
        }
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/index.jsx